import type { SessionData } from 'owa-service/lib/types/SessionData';

export default function (): Promise<SessionData> {
    return Promise.resolve({
        owaUserConfig: {
            UserOptions: {
                TimeZone: 'UTC',
            },
        },
        language: 'en',
        features: [],
    });
}
